import React, { useState, useEffect } from "react";
import get from "lodash/get";
import { connect } from "react-redux";
import { Button } from "../../atoms/button";
import { SUBSCRIPTION_PAGE_URL } from "../../../constants";

import "./subscription-status-btn.m.css";

const SubscriptionStatusBtnWrapper = ({ member = {}, userSubscription, userHasSubscription }) => {
  const getOnetimePlan = userSubscription.filter(item => item["plan_occurrence"] === "One Time") || [];
  const getRecuringPlan =  userSubscription.filter(item => item["plan_occurrence"] === "Recurring") || [];
  const checkActiveOTS = userHasSubscription && userSubscription.filter(item => item["plan_occurrence"] === "One Time" && item.active === true) || [];
  const checkActiveRS =  userHasSubscription && userSubscription.filter(item => item["plan_occurrence"] === "Recurring" && item.active === true) || [];
  const checkExpiredOTS = getOnetimePlan.filter(item => item.status === "expired") || [];
  const checkExpiredRS = checkActiveRS.filter(item => item.status === "expired") || [];
  const getButtonText = () => {
    if (member) {
      if (checkActiveOTS.length > 0) {
        return "Extend";
      } else if (checkActiveRS.length > 0) {
        return "Gift";
      } else if (checkExpiredOTS.length > 0 || checkExpiredRS.length > 0) {
        return "Renew";
      } else return "Subscribe";
    }
    return "Subscribe";
  };

  return <Button href={SUBSCRIPTION_PAGE_URL}> {getButtonText()} </Button>;
};

const mapStateToProps = state => {
  return {
    member: get(state, ["member"], null),
    userSubscription: get(state, ["isSubscribedUser", "userSubscription"], []),
    userHasSubscription: get(state, ["isSubscribedUser", "userHasSubscription"], false),
    
  };
};

export const SubscriptionStatusBtn = connect(mapStateToProps, null)(SubscriptionStatusBtnWrapper);
